import { PipeTransform, Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18NText } from '../api/model/i18NText';

@Pipe({
  name: 'i18nText',
  pure: false,
})
export class I18nTextPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  public transform(value: I18NText | null | undefined): string | null {
    let translatedValue = null;
    if (value) {
      const currentLanguage = this.translateService.currentLang;
      translatedValue = value.germanText ?? null;
      if (currentLanguage === 'fr') {
        translatedValue = value.frenchText ?? null;
      }
    }

    return translatedValue;
  }
}
